import React from 'react'
import { connect } from 'react-redux'
import { CSSTransition } from 'react-transition-group'

import { RootStateTypeExtra } from '@store/types'

import AreaList, { Area } from './area-list'

type BlockListProps = {
  className?: string
  containerClassName?: string
  blocks: string[]
  selectedBlock: string | undefined
  onSelect: (id: string) => void
}

function BlockList({
  className = '',
  containerClassName = '',
  blocks,
  selectedBlock,
  onSelect,
}: BlockListProps) {
  const areaListProp = React.useMemo<Area[]>(
    () =>
      blocks.map<Area>((item) => ({
        id: item,
        name: item,
        selected: selectedBlock === item,
      })),
    [blocks, selectedBlock]
  )

  const handleClick = React.useCallback(
    (item: Area) => {
      onSelect(item.id)
    },
    [onSelect]
  )

  return (
    <CSSTransition
      classNames="transition-property-compare-toggle"
      timeout={300}
      in
      appear
      mountOnEnter
      unmountOnExit
    >
      <div className={`h-full w-full ${className}`}>
        <div
          className={`custom-scrollbar h-full w-full overflow-y-auto ${containerClassName}`}
        >
          <AreaList data={areaListProp} onClick={handleClick} />
        </div>
      </div>
    </CSSTransition>
  )
}

export default connect(({ projectIdentity }: RootStateTypeExtra) => ({
  projectId: projectIdentity.projectId,
}))(BlockList)
